import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { AppContext } from "../context";
import {
  addImageToList,
  setLog,
  userLogs,
  patLogs,
  imageFeedbackLambda,
  setFeedBackStatus,
  feedBackStatus,
  resumeFlowFinalSubmitHandler,
  translateText,
  setImageFeedbackResumeStatus,
  setFeedbackCountResume,
  getFeedbackCountResume,
  getTotalImageFeedbackMssgResume,
  setSubCompleted,
  getSubCompleted,
  getTotalImageForAnalysisResume,
  setSubMandatoryCompleted,
  getSubMandatoryCompleted,
  getTotalImageFeedbackMssg,
  getImageFeedbackStatusNBtn,
  isAllImgUploaded,
  isImgExistFeedbackList,
  getKotakRecaptureCase,
  setKotakRecapMenuSection,
  setKotakRecapSubSection,
  getKotakRecapSubSection,
  getConstraint,
  getAspectRatioClientList,
  setImgFeedbackFlag,
  setCountDownTimer,
  getCountDownTimer,
  setGlobalImageQueue,
  getFeedbackTimer,
  setImgFeedbackCount,
  getImgFeedbackCount,
  setCameraOpenFlag,
  getCameraOpenFlag,
  getWebpImageFormat,
  getDocumentTagIndex,
  getImgQualityFactor,
  getNewConfirmBtn,
  getRecaptureColorCoding
} from "../context/utils";
import cameraImg from "../img/camera.png";
import Button from "./Button";
import Rotate from "./Rotate";
import leftArrow from "../img/left.png";
import rightArrow from "../img/right.png";
import car_inspection from "../img/car_inspection.png";
import white_tick from "../img/white_tick.png";
import SafeImage from "./SafeImage";
import { startVideoPlayback } from "../utils_new/videoPlayback";
// import picture1 from "../img/Picture1.jpg";

// import ReactGA from "react-ga4";
import { incompleteBlockColor } from "../utils_new/theme";
let count = 0;
let logBugs = true;
let currentSubBlock = "";
let currentTag = "";
let imageCaptured = false;
let image = {};
let overlaidImage = null;
let alignment = false;
let mandatoryMissing = [];
let subMissing = [];
// let cameraStarted = false;
let track = null;
let reservedData = null;
let tempStoredFeedBack = {};
let feedBackImages;
let videoConstraints;
let stencilUrl = "";
let videoEl;
let timerInterval;
let checkdoc = null;
let feedBackStatusOnce = true;
let instFlag = true;

const MultipleImage = () => {
  const {
    callOnceFeedBack,
    setCallOnceFeedBack,
    totalImageForAnalysis,
    setTotalImageForAnalysis,
    stepCovered,
    setStepCovered,
    clientId,
    showAlert,
    condition,
    setCondition,
    setScreen,
    currentBlock,
    showOptions,
    setShowOptions,
    config,
    isLandscape,
    setLandscape,
    mandatory,
    setMandatory,
    subMandatory,
    setSubMandatory,
    setCurrentPage,
    inspectionId,
    subCondition,
    setSubCondition,
    count1,
    setCount1,
    scrollX,
    setscrollX,
    scrolEnd,
    setscrolEnd,
    feedBackBtndisabled,
    setFeedBackBtndisabled,
    feedBackMssg,
    setFeedBackMssg,
    feedbackReceived,
    setFeedbackReceived,
    setImageFeedbackPopupRef,
    isIOS,
  } = useContext(AppContext);

  const land = () => window.innerWidth > window.innerHeight * 1.2;

  const isInIframe = () => {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  };

  const [instructions, setInstructions] = useState(null);
  const [currentBlockItem, setCurrentBlockItem] = useState(
    currentBlock["values"],
  );
  const [shadowUrl, setShadowUrl] = useState("");
  const [timeOutTimer, setTimeOutTimer] = useState(getFeedbackTimer());
  const documentVerificationFlag = [
    "Vehicle Registration",
    "Certificate of Current Annotations",
    "First Registration Request",
    "Transfer Certificate",
    "Signed Purchase-Sale Contract",
    "First Registration",
    "Sales Invoice",
  ].includes(getDocumentTagIndex());
  // clients that may keep a flagged 360 image instead of recapturing it
  const continueFeedbackFlag = [
    "liberty_dev",
    "liberty_prod",
    
  ].includes(clientId);
  // console.log(
  //   "documentVerificationFlag",
  //   documentVerificationFlag,
  //   getDocumentTagIndex(),
  // );
  // window.onresize = () => {

  // window.onresize = () => {
  //   setLandscape(land());
  //   if (!land()) {
  //     cameraStarted = false;
  //   }
  //   else if (land()) {
  //     if (!cameraStarted) startCamera();
  //     if (cameraStarted) stencilResize();
  //   }
  // };

  const getTranslateText = (text) => {
    if (Object.keys(config["language"]).includes(text)) {
      return config["language"][text];
    } else {
      // const data = translateText(text, config["language"]["langCode"]);
      return text;
    }
  };

  const [reduce, setReduce] = useState(false);
  const [isStreamRotated, setIsStreamRotated] = useState(false);
  if (logBugs) {
    patLogs(`Entered to ${currentBlock.tag}`, inspectionId);
    // ReactGA.send({
    //   hitType: "pageview",
    //   page: `${currentBlock.tag}`,
    //   title: `${currentBlock.tag}`,
    // });
    userLogs({
      position: 8,
      last_page: `${currentBlock.tag} Module`,
      inspectionId,
    });
  }
  logBugs = false;
  const cardDashboardRef = useRef();
  const singleScreen = useRef();
  const videoRef = useRef();
  const canvasRef = useRef();
  const cameraRequestInFlightRef = useRef(false);
  const resizeDebounceRef = useRef(null);
  const startBtn = useRef();
  const imgRef = useRef();
  const modalRef = useRef();
  const divImgRef = useRef();
  let scrl = useRef();
  const feedBackPopUp = useRef();
  const redLineVINcontainer = useRef();
  const stencilBoxRef = useRef();
  const successDOcFeedback = useRef();
  const gettingDocFeedback = useRef();
  const gettingDocFeedbackText = useRef();
  const gettingDocFeedbackButton = useRef();

  const stencilResize = () => {
    requestAnimationFrame(() => {
      const containerWidth = window.innerWidth;
      const containerHeight = window.innerHeight;

      const videoAspect = isStreamRotated
        ? videoEl.videoHeight / videoEl.videoWidth
        : videoEl.videoWidth / videoEl.videoHeight;
      const containerAspect = containerWidth / containerHeight;

      let displayWidth, displayHeight;

      if (videoAspect > containerAspect) {
        // Video is wider — full width, black bars top/bottom
        displayWidth = containerWidth;
        displayHeight = containerWidth / videoAspect;
      } else {
        // Video is taller — full height, black bars sides
        displayHeight = containerHeight;
        displayWidth = containerHeight * videoAspect;
      }

      // Apply box size and position
      if (stencilBoxRef?.current && stencilUrl) {
        const box = stencilBoxRef.current;
        box.style.width = `${displayWidth}px`;
        box.style.height = `${displayHeight}px`;
        box.style.left = `${(containerWidth - displayWidth) / 2}px`;
        box.style.top = `${(containerHeight - displayHeight) / 2}px`;
        box.style.position = "absolute";
        box.style.display = "flex";
        box.style.pointerEvents = "none";
      }

      // Show buttons/overlays
    });
  };

  const startCamera = () => {
    try {
      const guardInFlight = isIOS;
      if (guardInFlight) {
        if (cameraRequestInFlightRef.current) return;
        cameraRequestInFlightRef.current = true;
      }
      navigator.mediaDevices
        .getUserMedia(getConstraint(config, clientId))
        .then((stream) => {
          if (window.stream) {
            window.stream.getTracks().forEach((track) => track.stop());
            window.stream = null;
          }
          window.stream = stream;
          track = stream.getTracks()[0];
          videoEl = videoRef.current;
          if (videoEl) {
            videoEl.srcObject = stream;
            startVideoPlayback(videoEl, config);
            videoEl.onloadedmetadata = () => {
              const isRotated = videoEl.videoWidth < videoEl.videoHeight && window.innerWidth > window.innerHeight;
              setIsStreamRotated(isRotated);
              if (reservedData) {
                divImgRef.current.src = reservedData;
                imgRef.current.style.display = "block";
              }
              // cameraStarted = true;
              setCameraOpenFlag(true);
              stencilResize();
              setTimeout(() => {
                if (startBtn.current) startBtn.current.style.display = "block";
              }, 300);
            };
            if (
              ["sompo_motorbike"].includes(clientId) &&
              redLineVINcontainer.current
            ) {
              redLineVINcontainer.current.style.display = "flex";
            }
          } else {
            setTimeout(() => {
              if (videoRef.current) {
                videoRef.current.srcObject = stream;
                startVideoPlayback(videoRef.current, config);
                videoRef.current.onloadedmetadata = () => {
                  const currentVideoEl = videoRef.current;
                  const isRotated = currentVideoEl.videoWidth < currentVideoEl.videoHeight && window.innerWidth > window.innerHeight;
                  setIsStreamRotated(isRotated);
                  if (reservedData) {
                    divImgRef.current.src = reservedData;
                    imgRef.current.style.display = "block";
                  }
                  // cameraStarted = true;
                  setCameraOpenFlag(true);
                  stencilResize();
                  setTimeout(() => {
                    if (startBtn.current)
                      startBtn.current.style.display = "block";
                  }, 300);
                };
                if (
                  ["sompo_motorbike"].includes(clientId) &&
                  redLineVINcontainer.current
                ) {
                  redLineVINcontainer.current.style.display = "flex";
                }
              }
            }, 200);
          }
        })
        .finally(() => {
          if (guardInFlight) cameraRequestInFlightRef.current = false;
        });
    } catch (err) {
      // console.log(err);
      if (isIOS) cameraRequestInFlightRef.current = false;
    }
  };

  const captureImg = async () => {
    // patLogs("capture image button clicked", inspectionId);
    const cnv = canvasRef.current;
    const vw = videoRef.current;
    if (isStreamRotated) {
      cnv.width = vw.videoHeight;
      cnv.height = vw.videoWidth;
      const ctx = cnv.getContext("2d");
      ctx.translate(cnv.width / 2, cnv.height / 2);
      ctx.rotate((90 * Math.PI) / 180);
      ctx.drawImage(vw, -vw.videoWidth / 2, -vw.videoHeight / 2);
    } else {
      cnv.width = vw.videoWidth;
      cnv.height = vw.videoHeight;
      cnv.getContext("2d").drawImage(vw, 0, 0);
    }
    const imgData =
      getWebpImageFormat() && !isIOS
        ? cnv.toDataURL("image/webp", getImgQualityFactor())
        : cnv.toDataURL("image/jpeg");

    let overlaidImgData = null;
    try {
      if (
        Object.keys(config).includes("stencil-overlay") &&
        config["stencil-overlay"] &&
        stencilBoxRef.current &&
        stencilBoxRef.current.style.display !== "none"
      ) {
        const tempCanvas = document.createElement("canvas");
        tempCanvas.width = isStreamRotated ? vw.videoHeight : vw.videoWidth;
        tempCanvas.height = isStreamRotated ? vw.videoWidth : vw.videoHeight;
        const tempCtx = tempCanvas.getContext("2d");
        if (isStreamRotated) {
          tempCtx.save();
          tempCtx.translate(tempCanvas.width / 2, tempCanvas.height / 2);
          tempCtx.rotate((90 * Math.PI) / 180);
          tempCtx.drawImage(vw, -vw.videoWidth / 2, -vw.videoHeight / 2);
          // drop the rotation so the stencil overlay below is drawn upright
          tempCtx.restore();
        } else {
          tempCtx.drawImage(vw, 0, 0);
        }

        const imgElement = stencilBoxRef.current.querySelector("img");
        let drawSuccess = false;

        if (
          imgElement &&
          imgElement.src &&
          !imgElement.src.includes("shadowBox")
        ) {
          const tempImg = new Image();
          tempImg.crossOrigin = "anonymous";
          let noCacheSrc = imgElement.src;
          if (noCacheSrc.includes("?")) {
            noCacheSrc += "&cb=" + new Date().getTime();
          } else {
            noCacheSrc += "?cb=" + new Date().getTime();
          }
          tempImg.src = noCacheSrc;
          await new Promise((resolve) => {
            tempImg.onload = resolve;
            tempImg.onerror = resolve;
          });
          if (tempImg.complete && tempImg.naturalWidth > 0) {
            let scaleFactor =
              /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
                ? 0.9
                : 1.0;
            let sW = tempImg.naturalWidth;
            let sH = tempImg.naturalHeight;
            let canvasAspect = tempCanvas.width / tempCanvas.height;
            let imgAspect = sW / sH;

            let dWidth, dHeight;
            if (imgAspect > canvasAspect) {
              dWidth = tempCanvas.width * scaleFactor;
              dHeight = (tempCanvas.width / imgAspect) * scaleFactor;
            } else {
              dHeight = tempCanvas.height * scaleFactor;
              dWidth = tempCanvas.height * imgAspect * scaleFactor;
            }
            let dx = (tempCanvas.width - dWidth) / 2;
            let dy = (tempCanvas.height - dHeight) / 2;
            tempCtx.drawImage(tempImg, dx, dy, dWidth, dHeight);
            drawSuccess = true;
          }
        }

        if (drawSuccess) {
          overlaidImgData =
            getWebpImageFormat() && !isIOS
              ? tempCanvas.toDataURL("image/webp", getImgQualityFactor())
              : tempCanvas.toDataURL("image/jpeg");
        }
      }
    } catch (e) {
      // console.error("Error creating overlaid image:", e);
    }

    divImgRef.current.src = imgData;
    reservedData = imgData;
    let region = Object.keys(config["video-page"]).includes("clientRegion")
      ? config["video-page"]["clientRegion"]
      : "eu-central-1";
    image = {
      name: Array.isArray(currentBlock["tag"])
        ? `${getDocumentTagIndex()}.jpg`
        : `${currentTag}.jpg`,
      imgData: imgData,
      tag: Array.isArray(currentBlock["tag"])
        ? `${getDocumentTagIndex()}: ${currentTag}`
        : `${currentBlock.tag}: ${currentTag}`,
      web_region: null,
      angle: null,
      region: region,
      env: 1,
      videoData: null,
      dialStatus: null,
      currentTag,
      currentBlockName: currentBlock["id"],
      currentSubBlock,
      overlayStencil: overlaidImgData ? true : false,
      imageFeedbackFlag:
        Object.keys(config).includes("resumeFlow") &&
        config["resumeFlow"] &&
        Object.keys(config).includes("imageFeedback") &&
        currentBlock["tag"] === "360 Image",
    };
    if (overlaidImgData) {
      let ogName = image.name;
      let newName = ogName.replace(".jpg", "-stencil.jpg");
      overlaidImage = {
        ...image,
        name: newName,
        imgData: overlaidImgData,
        tag: image.tag + "-stencil",
      };
    } else {
      overlaidImage = null;
    }
    if (redLineVINcontainer.current)
      redLineVINcontainer.current.style.display = "none";
    imgRef.current.style.display = "block";
  };

  const slide = (shift) => {
    scrl.current.scrollLeft += shift;
    setscrollX(scrollX + shift);
    if (
      Math.floor(scrl.current.scrollWidth - scrl.current.scrollLeft) <=
      scrl.current.offsetWidth
    ) {
      setscrolEnd(true);
    } else {
      setscrolEnd(false);
    }
  };

  const scrollCheck = () => {
    setscrollX(scrl.current.scrollLeft);
    if (
      Math.floor(scrl.current.scrollWidth - scrl.current.scrollLeft) <=
      scrl.current.offsetWidth
    ) {
      setscrolEnd(true);
    } else {
      setscrolEnd(false);
    }
  };

  const imageRetake = () => {
    // patLogs("retake button clicked to capture image again", inspectionId);
    reservedData = null;
    if (redLineVINcontainer.current)
      redLineVINcontainer.current.style.display = "flex";
    imgRef.current.style.display = "none";
  };

  const goBack = () => {
    if (stencilBoxRef?.current) {
      stencilBoxRef.current.style.display = "none";
    }
    if (
      feedBackStatus() === "Feedback" &&
      currentBlock["tag"] === "360 Image"
    ) {
      patLogs("back button clicked", inspectionId);
      modalRef.current.style.display = "flex";
      logBugs = true;
      return;
    }
    // cameraStarted = false;
    setCameraOpenFlag(false);
    setSubCompleted(false);
    setSubMandatoryCompleted(false);
    currentSubBlock = "";
    currentTag = "";
    instFlag = true;
    alignment = false;
    setScreen("menu");
  };

  const removeModal = () => {
    // patLogs(
    //   `user clicked cross button to close warning and move to ${currentBlock.id}`,
    //   inspectionId
    // );
    if (modalRef && modalRef.current) modalRef.current.style.display = "none";
  };
  const modal = () => {
    if (
      getSubCompleted() ||
      (Object.keys(config).includes("resumeFlow") &&
        config["resumeFlow"] &&
        Object.keys(config).includes("imageFeedback") &&
        currentBlock["tag"] === "360 Image" &&
        getImgFeedbackCount() >= 8)
    ) {
      imageAnalysis();
      return;
    }
    if (!getSubMandatoryCompleted() || !getSubCompleted()) {
      patLogs(
        `clicked to submit button, Warning given to user some option is not completed`,
        inspectionId,
      );
      if (modalRef && modalRef.current) modalRef.current.style.display = "flex";
      return;
    }
  };

  const setFeedbackReceivedHanlder = (currentTag) => {
    if (feedBackImages) {
      let temp = feedBackImages.filter((e) => e !== currentTag);
      feedBackImages = temp;
    }
  };

  useEffect(() => {
    if (!isLandscape) {
      return;
    }
    if (checkdoc === null) {
      return;
    }
    if (Object.keys(checkdoc).length === 0 && feedBackStatusOnce) {
      gettingDocFeedback.current.style.display = "flex";
      gettingDocFeedbackText.current.innerHTML = getTranslateText(
        "Hang tight! We’re analyzing your image — this will only take a few seconds.",
      );
    } else {
      if (!checkdoc || typeof checkdoc.document_quality !== "boolean") {
        gettingDocFeedbackText.current.innerHTML = getTranslateText(
          "Unable to validate the image. Please capture again.",
        );
        gettingDocFeedbackButton.current.style.display = "flex";
        return;
      }
      if (checkdoc.document_quality) {
        feedBackStatusOnce = false;
        gettingDocFeedback.current.style.display = "none";
        successDOcFeedback.current.style.display = "flex";
        setTimeout(() => {
          imageNext();
        }, 2000);
      } else {
        gettingDocFeedbackText.current.innerHTML = getTranslateText(
          "It looks like this is not an document image. Please capture again.",
        );
        gettingDocFeedbackButton.current.style.display = "flex";
      }
    }
  }, [isLandscape]);

  const docCheckingHandler = async () => {
    checkdoc = await imageFeedbackLambda({
      inspection_id: inspectionId,
      image:
        getWebpImageFormat() && !isIOS
          ? image["imgData"].replace(/^data:image\/webp;base64,/, "")
          : image["imgData"].replace(/^data:image\/jpeg;base64,/, ""),
      tag: "document",
      client_id: clientId,
      type: "document",
      region: image["region"],
    });

    patLogs(
      `DOCUMENT Feedback Response: ${JSON.stringify(checkdoc)}`,
      inspectionId,
    );

    if (!checkdoc || typeof checkdoc.document_quality !== "boolean") {
      gettingDocFeedbackText.current.innerHTML = getTranslateText(
        "Unable to validate the image. Please capture again.",
      );
      gettingDocFeedbackButton.current.style.display = "flex";
      return;
    }

    // ✅ TRUE means it is engine image
    if (checkdoc.document_quality) {
      feedBackStatusOnce = false;
      gettingDocFeedback.current.style.display = "none";
      successDOcFeedback.current.style.display = "flex";
      setTimeout(() => {
        imageNext();
      }, 2000);
    } else {
      // ❌ FALSE means not engine image
      gettingDocFeedbackText.current.innerHTML = getTranslateText(
        "It looks like this is not an document image. Please capture again.",
      );
      gettingDocFeedbackButton.current.style.display = "flex";
    }
  };

  const imageNext = () => {
    if (documentVerificationFlag && feedBackStatusOnce && Array.isArray(currentBlock["tag"])) {
      docCheckingHandler();
      checkdoc = {};
      gettingDocFeedback.current.style.display = "flex";
      gettingDocFeedbackText.current.innerHTML = getTranslateText(
        "Hang tight! We’re analyzing your image — this will only take a few seconds.",
      );
    } else {
      feedBackStatusOnce = true;
      checkdoc = null;
      setGlobalImageQueue(image);
      if (stencilBoxRef?.current) {
        stencilBoxRef.current.style.display = "none";
      }
      logBugs = true;
      // patLogs(
      //   `tick button clicked image sent for uploading... and return to ${currentBlock.id}`,
      //   inspectionId
      // );
      reservedData = null;
      if (imageCaptured) return;
      // cameraStarted = false;
      setCameraOpenFlag(false);
      imgRef.current.style.display = "none";
      imageCaptured = true;
      window.stream = null;
      track.stop();
      let temp2 = subCondition;
      temp2[currentBlock.id][currentSubBlock] = "completed";
      setSubCondition(temp2);
      currentBlock.values.map((item) => {
        if (item.name === currentSubBlock && item.mandatory) {
          let temp3 = subMandatory;
          temp3[currentBlock.id][currentSubBlock] = "completed";
          setSubMandatory(temp3);
        }
      });
      setKotakRecapSubSection(currentBlock["tag"], currentTag);
      setLog(`${currentTag} was captured`);
      //send image here----
      if (
        Object.keys(config).includes("imageFeedback") &&
        currentBlock.tag === "360 Image" &&
        feedbackReceived.length === 0
      ) {
        setTotalImageForAnalysis([...totalImageForAnalysis, image]);
        if (overlaidImage) {
          addImageToList(overlaidImage);
        }
        //setFeedbackCountResume(1 + getFeedbackCountResume());
        setImgFeedbackCount(1 + getImgFeedbackCount());
        if (
          getImgFeedbackCount() >= 8 &&
          Object.keys(config).includes("resumeFlow") &&
          config["resumeFlow"]
        ) {
          setSubMandatoryCompleted(true);
        }
        checkImage(currentTag);
        count = count + 1;
      } else {
        if (feedBackImages && feedBackImages.length > 0) {
          setFeedbackReceivedHanlder(currentTag);
        }
        setFeedbackReceived(feedbackReceived.filter((e) => e !== currentTag));
        addImageToList(image);
        if (overlaidImage) {
          addImageToList(overlaidImage);
        }
        if (feedbackReceived.length === 1) {
          setFeedBackBtndisabled(false);
          setFeedBackStatus("noFeedback");
          setImageFeedbackResumeStatus("noFeedback", false);
        }
      }
      checkAll();
      if (process.env.REACT_APP_IMAGE_SLIDER) {
        sortBlock();
      }
      setCount1(count1 + 1);
      setShowOptions(true);
      if (
        Object.keys(config).includes("imageFeedback") &&
        currentBlock.tag === "360 Image" &&
        feedbackReceived.length === 1
      ) {
        setImageFeedbackPopupRef(true);
        modal();
      }
    }
  };

  const checkImage = async (tag) => {
    let data = await imageFeedbackLambda({
      inspection_id: inspectionId,
      image:
        getWebpImageFormat() && !isIOS
          ? image["imgData"].replace(/^data:image\/webp;base64,/, "")
          : image["imgData"].replace(/^data:image\/jpeg;base64,/, ""),
      tag: tag,
      type:
        currentBlock["type"] && currentBlock["type"] === "bike"
          ? "bike"
          : "car",
      client_id: clientId,
      imageDate: image,
      resumeFlag:
        Object.keys(config).includes("imageFeedback") &&
        Object.keys(config).includes("resumeFlow") &&
        config["resumeFlow"],
    });
    if (data["feedback"].length > 0) {
    }
  };

  const sortBlock = () => {
    let tempCurrentBlock = currentBlockItem;
    if (
      feedbackReceived.length === 0 &&
      getTotalImageForAnalysisResume().length > 0 &&
      currentBlock["tag"] === "360 Image"
    ) {
      let totalImages = getTotalImageForAnalysisResume();
      tempCurrentBlock.sort((a, b) => {
        const aCompleted = totalImages
          .map((obj) => obj["currentTag"])
          .includes(a["tag"]);
        const bCompleted = totalImages
          .map((obj) => obj["currentTag"])
          .includes(b["tag"]);

        if (!aCompleted && bCompleted) return -1;
        if (aCompleted && !bCompleted) return 1;
        return 0;
      });
    } else if (
      feedBackImages &&
      feedBackImages.length > 0 &&
      currentBlock["tag"] === "360 Image"
    ) {
      tempCurrentBlock.sort((a, b) => {
        const aHasTag = feedBackImages.includes(a.tag);
        const bHasTag = feedBackImages.includes(b.tag);

        if (aHasTag && !bHasTag) return -1;
        if (!aHasTag && bHasTag) return 1;

        return 0;
      });
    } else {
      const subMissingSet = new Set(subMissing);
      const subMandatoryMissingSet = new Set(mandatoryMissing);

      tempCurrentBlock.sort((a, b) => {
        const aMandatoryIncomplete = subMandatoryMissingSet.has(a.name);
        const bMandatoryIncomplete = subMandatoryMissingSet.has(b.name);

        const aIncomplete = subMissingSet.has(a.name);
        const bIncomplete = subMissingSet.has(b.name);

        // Sort by mandatory and incomplete status
        if (aMandatoryIncomplete && !bMandatoryIncomplete) return -1;
        if (!aMandatoryIncomplete && bMandatoryIncomplete) return 1;

        if (aMandatoryIncomplete && bMandatoryIncomplete) return 0;

        if (aIncomplete && !bIncomplete) return -1;
        if (!aIncomplete && bIncomplete) return 1;

        return 0;
      });
    }
    setCurrentBlockItem(tempCurrentBlock);
  };

  const checkAll = () => {
    let tempSubCheck = true;
    let tempMandCheck = true;
    mandatoryMissing = [];
    subMissing = [];
    currentBlock.values.map(async (item) => {
      if (subCondition[currentBlock.id][item.name] === "pending") {
        tempSubCheck = false;
        subMissing.push(item.name);
      }
      if (item.mandatory) {
        if (subMandatory[currentBlock.id][item.name] === "pending") {
          tempMandCheck = false;
          if (
            !(
              Object.keys(config).includes("resumeFlow") &&
              config["resumeFlow"] &&
              Object.keys(config).includes("imageFeedback") &&
              currentBlock["tag"] === "360 Image"
            )
          ) {
            mandatoryMissing.push(item.name);
          } else {
            if (
              !totalImageForAnalysis
                .map((e) => e["currentTag"])
                .includes(item.tag)
            ) {
              let hasImgExist = await isImgExistFeedbackList(
                item.name,
                inspectionId,
              );
              if (!hasImgExist) {
                mandatoryMissing.push(item.name);
              }
            }
          }
        }
      }
    });

    if (tempSubCheck) {
      setSubCompleted(true);
    }
    if (tempMandCheck) {
      setSubMandatoryCompleted(true);
    }
  };

  const back = () => {
    // patLogs(
    //   `back button is clicked and return to ${currentBlock.id}`,
    //   inspectionId
    // );
    currentSubBlock = "";
    currentTag = "";
    imageCaptured = true;
    // cameraStarted = false;
    setCameraOpenFlag(false);
    window.stream = null;
    track.stop();
    setShowOptions(true);
  };

  const imageAnalysis = () => {
    if (
      Object.keys(config).includes("imageFeedback") &&
      currentBlock.tag === "360 Image"
    ) {
      if (callOnceFeedBack) {
        setCallOnceFeedBack(false);
        removeModal();
        setFeedBackStatus("checking");
        if (feedBackPopUp && feedBackPopUp.current)
          feedBackPopUp.current.style.display = "flex";
        if (
          Object.keys(config).includes("resumeFlow") &&
          config["resumeFlow"]
        ) {
          alignment = false;
          finsh(false);
        }
        setTimeout(async () => {
          let result = await isAllImgUploaded(inspectionId);
          let imageFeedbackMsg = getTotalImageFeedbackMssgResume();
          let tempmsgFeedback = {};
          setImgFeedbackFlag(true);
          if (Object.keys(imageFeedbackMsg).length > 0) {
            for (let e in imageFeedbackMsg) {
              if (imageFeedbackMsg[e].length > 0) {
                tempmsgFeedback[e] = imageFeedbackMsg[e];
              }
            }
            if (
              Object.keys(config).includes("resumeFlow") &&
              config["resumeFlow"]
            ) {
              if (Object.keys(tempmsgFeedback).length > 0)
                setFeedbackReceived(Object.keys(tempmsgFeedback));
              if (Object.keys(tempmsgFeedback).length > 0 && result)
                setImageFeedbackResumeStatus("Feedback", true);
              else if (result)
                setImageFeedbackResumeStatus("Feedback_Resume", true);
            } else {
              if (Object.keys(tempmsgFeedback).length > 0)
                setFeedbackReceived(Object.keys(tempmsgFeedback));
            }
            setFeedBackBtndisabled(true);
            setFeedBackStatus("Feedback");
            setFeedbackCountResume(0);
          }

          totalImageForAnalysis.map((e) => {
            if (!Object.keys(imageFeedbackMsg).includes(e.currentTag)) {
              addImageToList(e);
            } else {
              if (imageFeedbackMsg[e.currentTag].length === 0) {
                addImageToList(e);
              } else {
                setFeedBackStatus("Feedback");
              }
            }
          });
          if (
            Object.keys(getTotalImageFeedbackMssg()).length === 0 ||
            Object.keys(tempmsgFeedback).length === 0
          ) {
            setFeedBackStatus("noFeedback");
            return;
          }
          clearInterval(timerInterval);
          userLogs({
            position: 17,
            feedback_countDown: feedBackStatus() + " " + 1,
            inspectionId,
          });
        }, timeOutTimer);
        if (["client_hiib", "client_hiib_uat", ""].includes(clientId)) {
          timerInterval = setInterval(() => {
            let count = getCountDownTimer();
            if (count > -10) {
              let tempcount = count - 1;
              setCountDownTimer(tempcount);
            } else {
              clearInterval(timerInterval);
            }
          }, 1000);
        }
      } else {
        finsh(true);
        alignment = false;
      }
    } else {
      finsh(true);
      alignment = false;
    }
  };

  const finsh = async (value) => {
    if (!getSubMandatoryCompleted) return;
    patLogs(`${currentBlock.id} is completed`, inspectionId);
    // cameraStarted = false;
    setCameraOpenFlag(false);
    let temp = condition;
    if (currentBlock.mandatory) {
      let temp1 = mandatory;
      temp1[currentBlock.id] = "completed";
      setMandatory(temp1);
    }
    image = {};
    currentSubBlock = "";
    currentTag = "";
    imageCaptured = false;
    temp[currentBlock.id] = "completed";
    setLog(`${currentBlock["tag"]} was finished`);
    setSubCompleted(false);
    setSubMandatoryCompleted(false);
    setCondition(temp);
    setKotakRecapMenuSection(currentBlock["tag"]);
    if (Object.keys(config).includes("resumeFlow") && config["resumeFlow"]) {
      let result = await isAllImgUploaded(inspectionId);
      if (
        currentBlock["tag"] === "360 Image" &&
        Object.keys(config).includes("imageFeedback") &&
        result
      ) {
        //resumeFlowFinalSubmitHandler(currentBlock["id"]);
        setImageFeedbackResumeStatus("checking", false);
      } else if (
        currentBlock["tag"] !== "360 Image" ||
        !Object.keys(config).includes("imageFeedback")
      ) {
        resumeFlowFinalSubmitHandler(currentBlock["id"]);
      }
    }
    if (value) {
      setScreen("menu");
    }
  };

  useEffect(() => {
    if (Object.keys(currentBlock).includes("instruction-page") && currentBlock["instruction-page"] && instFlag) {
      cardDashboardRef.current.style.display = "flex";
      instFlag = false;
    }
    if (stencilBoxRef.current) {
      stencilBoxRef.current.style.display = "none";
    }
    setLandscape(land());
    checkAll();
    setCount1(count1 + 1);
    if (currentBlock["values"].length <= 3) {
      alignment = true;
    }
    imageCaptured = true;
    currentBlock["values"].map((e) => {
      if (e["name"].length > 14) {
        setReduce(true);
      }
    });
    if (feedbackReceived.length > 0) {
      feedBackImages = feedbackReceived;
    }
    if (process.env.REACT_APP_IMAGE_SLIDER) {
      sortBlock();
    }
    if (
      Object.keys(config).includes("resumeFlow") &&
      config["resumeFlow"] &&
      Object.keys(config).includes("imageFeedback") &&
      currentBlock["tag"] === "360 Image"
    ) {
      if (feedBackStatus() === "Feedback") {
        setSubMandatoryCompleted(true);
        setSubCompleted(true);
      } else if (
        ["", "checking"].includes(getImageFeedbackStatusNBtn()[0]) &&
        (getImgFeedbackCount() >= 8 ||
          Object.keys(getTotalImageFeedbackMssgResume()).length >= 8)
      ) {
        setSubCompleted(true);
        setSubMandatoryCompleted(true);
      }
    }
  }, []);

  useEffect(() => {
    const checkOrientation = () => {
      const isL = land();
      setLandscape(isL);
      if (!isL) {
        if (isIOS && window.stream) {
          window.stream.getTracks().forEach((t) => t.stop());
          window.stream = null;
          track = null;
        }
        setCameraOpenFlag(false);
        setIsStreamRotated(false);
      } else {
        if (!getCameraOpenFlag()) {
          // iOS needs a longer cooldown for the previous capture
          // session to fully release before requesting a new one, otherwise
          // repeated rotations can leave the stream stuck at stale metadata
          const restartDelay = isIOS ? 300 : 100;
          setTimeout(() => startCamera(), restartDelay);
        } else {
          const videoEl = videoRef.current;
          if (videoEl) {
            const isRotated = videoEl.videoWidth < videoEl.videoHeight && window.innerWidth > window.innerHeight;
            setIsStreamRotated(isRotated);
          }
        }
      }
    };
    const handleResize = () => {
      if (isIOS) {
        // collapse the burst of resize events fired mid-rotation on iOS
        // into a single check once the orientation settles
        if (resizeDebounceRef.current) clearTimeout(resizeDebounceRef.current);
        resizeDebounceRef.current = setTimeout(checkOrientation, 200);
      } else {
        checkOrientation();
      }
    };
    // Menu/Instructions and friends assign window.onresize during render and
    // never clear it on unmount. That stale handler calls setLandscape()
    // undebounced, which would flip orientation mid-rotation and defeat the
    // debounce above. Park it while this view owns the screen.
    const previousOnResize = window.onresize;
    window.onresize = null;

    window.addEventListener("resize", handleResize);
    return () => {
      window.onresize = previousOnResize;
      window.removeEventListener("resize", handleResize);
      if (resizeDebounceRef.current) clearTimeout(resizeDebounceRef.current);
      if (window.stream) {
        window.stream.getTracks().forEach((track) => track.stop());
        window.stream = null;
      }
    };
  }, []);

  const showFeedBackMssg = (value) => {
    setFeedBackMssg(value);
  };

  const captureFeedBackImage = (item) => {
    setFeedBackMssg("");
    patLogs(`${item["tag"]} is clicked`, inspectionId);
    currentSubBlock = item["name"];
    currentTag = item["tag"];
    setShowOptions(false);
    imageCaptured = false;
    startCamera();
    Object.keys(item).includes("cameraInstruction") &&
      setInstructions(item["cameraInstruction"]);
  };

  // latest capture of a tag that was sent for analysis, from this session or
  // restored by the resume flow
  const getPreviousCapture = (tag) => {
    const latest = (list) =>
      (list || [])
        .filter((e) => e && e["currentTag"] === tag && e["imgData"])
        .pop();
    return (
      latest(totalImageForAnalysis) ||
      latest(getTotalImageForAnalysisResume())
    );
  };

  // keep the earlier capture despite its feedback: upload it and clear the
  // flag the same way imageNext does after a recapture
  const continueFeedBackImage = (item) => {
    const previousImage = getPreviousCapture(item["tag"]);
    if (!previousImage) return;
    patLogs(
      `${item["tag"]} continued with previous image despite feedback`,
      inspectionId,
    );
    setFeedBackMssg("");
    addImageToList({ ...previousImage });
    let temp2 = subCondition;
    temp2[currentBlock.id][item["name"]] = "completed";
    setSubCondition(temp2);
    if (item["mandatory"]) {
      let temp3 = subMandatory;
      temp3[currentBlock.id][item["name"]] = "completed";
      setSubMandatory(temp3);
    }
    setLog(`${item["tag"]} was continued with previous image`);
    if (feedBackImages && feedBackImages.length > 0) {
      setFeedbackReceivedHanlder(item["tag"]);
    }
    setFeedbackReceived(feedbackReceived.filter((e) => e !== item["tag"]));
    if (feedbackReceived.length === 1) {
      setFeedBackBtndisabled(false);
      setFeedBackStatus("noFeedback");
      setImageFeedbackResumeStatus("noFeedback", false);
    }
    checkAll();
    if (process.env.REACT_APP_IMAGE_SLIDER) {
      sortBlock();
    }
    setCount1(count1 + 1);
    if (feedbackReceived.length === 1) {
      setImageFeedbackPopupRef(true);
      modal();
    }
  };

  const langConverstion = (value) => {
    if (Object.keys(config["imageFeedback"]["ReasonMssg"]).includes(value)) {
      return config["imageFeedback"]["ReasonMssg"][value];
    } else if (
      value.includes("You did not capture these parts in the image:")
    ) {
      if (
        Object.keys(config["imageFeedback"]["ReasonMssg"]).includes(
          "You did not capture these parts in the image:",
        )
      ) {
        let parts = value.split(":")[1].split(",");
        let partCoversion = "";
        parts.map((e) => {
          if (
            Object.keys(config["imageFeedback"]["ReasonMssg"]).includes(
              e.trim(),
            )
          ) {
            partCoversion = `${partCoversion}, ${config["imageFeedback"]["ReasonMssg"][e.trim()]}`;
          } else {
            partCoversion = e.trim();
          }
        });
        return `${config["imageFeedback"]["ReasonMssg"]["You did not capture these parts in the image:"].trim()} ${partCoversion}`;
      } else {
        return value;
      }
    } else if (value.includes("You captured the wrong side. Please capture")) {
      if (
        Object.keys(config["imageFeedback"]["ReasonMssg"]).includes(
          "You captured the wrong side. Please capture # again.",
        ) &&
        !config["imageFeedback"]["ReasonMssg"][
          "You captured the wrong side. Please capture # again."
        ].includes("#")
      ) {
        return config["imageFeedback"]["ReasonMssg"][
          "You captured the wrong side. Please capture # again."
        ];
      } else if (
        Object.keys(config["imageFeedback"]["ReasonMssg"]).includes(
          "You captured the wrong side. Please capture # again.",
        )
      ) {
        let detectRegion =
          config["imageFeedback"]["ReasonMssg"][value.split("#")[1].trim()] ||
          value.split("#")[1].trim();
        return `${config["imageFeedback"]["ReasonMssg"]["You captured the wrong side. Please capture # again."].split("#")[0].trim()} ${detectRegion} ${config["imageFeedback"]["ReasonMssg"]["You captured the wrong side. Please capture # again."].split("#")[1].trim()}`;
      } else {
        return value;
      }
    } else if (value.includes("You captured the wrong side. You captured ")) {
      if (
        Object.keys(config["imageFeedback"]["ReasonMssg"]).includes(
          "You captured the wrong side. You captured # in stead of # .",
        ) &&
        !config["imageFeedback"]["ReasonMssg"][
          "You captured the wrong side. You captured # in stead of # ."
        ].includes("#")
      ) {
        return config["imageFeedback"]["ReasonMssg"][
          "You captured the wrong side. You captured # in stead of # ."
        ];
      } else if (
        Object.keys(config["imageFeedback"]["ReasonMssg"]).includes(
          "You captured the wrong side. You captured # in stead of # .",
        )
      ) {
        let detectRegion1 =
          config["imageFeedback"]["ReasonMssg"][value.split("#")[1].trim()] ||
          value.split("#")[1].trim();
        let detectRegion2 =
          config["imageFeedback"]["ReasonMssg"][value.split("#")[3].trim()] ||
          value.split("#")[3].trim();
        return `${config["imageFeedback"]["ReasonMssg"]["You captured the wrong side. You captured # in stead of # ."].split("#")[0].trim()} ${detectRegion1} ${config["imageFeedback"]["ReasonMssg"]["You captured the wrong side. You captured # in stead of # ."].split("#")[1].trim()} ${detectRegion2} ${config["imageFeedback"]["ReasonMssg"]["You captured the wrong side. You captured # in stead of # ."].split("#")[2].trim()}`;
      } else {
        return value;
      }
    } else {
      return value;
    }
  };

  return (
    <Fragment>
      {!isLandscape ? (
        <Rotate />
      ) : showOptions ? (
        <div className="process" style={{ position: "relative" }}>
          <h2>{currentBlock["id"]}</h2>
          {
            Object.keys(currentBlock).includes("instruction-page") && currentBlock["instruction-page"] &&
            <div ref={cardDashboardRef} id="display-card-dashboard" style={{ zIndex: 5 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                  paddingTop: "2%",
                }}
              >
                <div
                  id="image-container"
                  style={{ width: "unset", paddingLeft: "2%" }}
                >
                  <SafeImage
                    style={{
                      width: "45dvw",
                      borderRadius: "5%",
                      height: "60dvh",
                    }}
                    src={currentBlock["inst-image"]}
                  />
                </div>
                <div id="dashboard-points">
                  <div style={{ display: "flex", gap: "2%" }}>
                    <div className="car-black"></div>
                    <p style={{ margin: "0px", padding: "0px", width: "90%" }}>
                      {currentBlock["instructions"][0]}
                    </p>
                  </div>
                  <div style={{ display: "flex", gap: "2%" }}>
                    <div className="car-black"></div>
                    <p style={{ margin: "0px", padding: "0px", width: "90%" }}>
                      {currentBlock["instructions"][1]}
                    </p>
                  </div>
                  {
                    currentBlock["instructions"].length > 2 &&
                    <div style={{ display: "flex", gap: "2%" }}>
                      <div className="car-black"></div>
                      <p style={{ margin: "0px", padding: "0px", width: "90%" }}>
                        {currentBlock["instructions"][2]}
                      </p>
                    </div>
                  }
                </div>
              </div>
              <div id="btn-container" style={{ paddingBottom: "unset" }}>
                <button
                  style={{
                    backgroundColor: config["colors"]["btn"],
                    color: "var(--btn-text, #fff)",
                    width: "20%",
                    height: "100%",
                    borderRadius: "10px",
                    border: "none",
                  }}
                  onClick={() => {
                    cardDashboardRef.current.style.display = "none";
                  }}
                >
                  {Object.keys(config["video-page"]).includes("continueText")
                    ? config["video-page"]["continueText"]
                    : getTranslateText("Continue")}
                </button>
              </div>
            </div>
          }
          <div ref={feedBackPopUp} className="imageFeedBackPopup">
            <div style={{ zIndex: 5 }}>
              <p style={{ margin: "2px" }}>
                {Object.keys(config).includes("imageFeedback") &&
                  Object.keys(config["imageFeedback"]).includes(
                    "ImageAnalysisMssg1",
                  )
                  ? config["imageFeedback"]["ImageAnalysisMssg1"]
                  : getTranslateText(
                    "It will take some time to analyse the images. Please continue to capture other sections",
                  )}
              </p>
              <img
                style={{ width: "80px", height: "80px" }}
                src={car_inspection}
              />
              <button
                className="feedbackbtn"
                style={{ backgroundColor: config["colors"]["btn"] }}
                onClick={() => {
                  feedBackPopUp.current.style.display = "none";
                  alignment = false;
                  if (
                    Object.keys(config).includes("resumeFlow") &&
                    config["resumeFlow"]
                  ) {
                    setScreen("menu");
                  } else {
                    finsh(true);
                  }
                }}
              >
                {Object.keys(config).includes("imageFeedback") &&
                  Object.keys(config["imageFeedback"]).includes("OtherBtnTxt")
                  ? config["imageFeedback"]["OtherBtnTxt"]
                  : getTranslateText("Other Sections")}
              </button>
            </div>
          </div>
          {feedBackMssg.length > 0 && (
            <div style={{ display: "flex" }} className="imageFeedBackPopup">
              <div
                style={{
                  justifyContent: "space-around",
                  textAlign: "left",
                  height: "45vh",
                  width: "55vw",
                  zIndex: 5,
                }}
              >
                <h2 style={{ margin: "0px" }}>
                  {Object.keys(config).includes("imageFeedback") &&
                    Object.keys(config["imageFeedback"]).includes("ReasonTxt")
                    ? config["imageFeedback"]["ReasonTxt"]
                    : getTranslateText("Reason")}
                </h2>
                <ul>
                  {feedBackMssg.map((e) => {
                    return (
                      <li style={{ padding: "2px 0px" }}>
                        {Object.keys(config).includes("imageFeedback")
                          ? langConverstion(e)
                          : e}
                      </li>
                    );
                  })}
                </ul>
                <div
                  style={{
                    flexDirection: "row",
                    width: "100%",
                    height: "auto",
                    padding: "0px",
                    gap: "12px",
                  }}
                >
                  <button
                    className="feedbackbtn"
                    style={{
                      backgroundColor: config["colors"]["btn"],
                      fontSize: "18px",
                    }}
                    onClick={() => {
                      captureFeedBackImage(tempStoredFeedBack);
                    }}
                  >
                    {Object.keys(config).includes("imageFeedback") &&
                      Object.keys(config["imageFeedback"]).includes(
                        "RecaptureBtnTxt",
                      )
                      ? config["imageFeedback"]["RecaptureBtnTxt"]
                      : getTranslateText("Recapture image")}
                  </button>
                  {continueFeedbackFlag &&
                    getPreviousCapture(tempStoredFeedBack["tag"]) && (
                      <button
                        className="feedbackbtn"
                        style={{
                          backgroundColor: "#fff",
                          color: config["colors"]["btn"],
                          border: `2px solid ${config["colors"]["btn"]}`,
                          fontSize: "18px",
                        }}
                        onClick={() => {
                          continueFeedBackImage(tempStoredFeedBack);
                        }}
                      >
                        {Object.keys(config).includes("imageFeedback") &&
                          Object.keys(config["imageFeedback"]).includes(
                            "ContinueBtnTxt",
                          )
                          ? config["imageFeedback"]["ContinueBtnTxt"]
                          : getTranslateText("Continue")}
                      </button>
                    )}
                </div>
              </div>
            </div>
          )}
          <div className="process-main" style={{ display: "flex" }}>
            <div
              className="left-btn"
              disabled={scrollX === 0}
              onClick={() => slide(-200)}
              style={alignment ? { display: "none" } : {}}
            >
              <img
                src={leftArrow}
                style={scrollX === 0 ? { opacity: "0.3" } : {}}
              />
            </div>
            <div
              className="process-steps"
              ref={scrl}
              onScroll={scrollCheck}
              style={
                alignment
                  ? {
                    display: "flex",
                    justifyContent: "center",
                    width: "100vw",
                  }
                  : {
                    display: "flex",
                    justifyContent: "flex-start",
                    width: "80vw",
                    overflowX: "scroll",
                    scrollBehavior: "smooth",
                    alignItems: "center",
                  }
              }
            >
              {currentBlockItem.map((item, index) => {
                if (
                  Object.keys(config).includes("resumeFlow") &&
                  config["resumeFlow"] &&
                  getTotalImageForAnalysisResume().length > 0 &&
                  getTotalImageForAnalysisResume()
                    .map((obj) => obj["currentTag"])
                    .includes(item["tag"]) &&
                  currentBlock["link"] ===
                  "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_360+view.svg"
                ) {
                  return (
                    <div key={index}>
                      <div
                        className="menu-options"
                        style={reduce ? { fontSize: "10px" } : null}
                      >
                        <h4
                          style={
                            feedbackReceived.includes(item.tag)
                              ? {
                                color: "red",
                              }
                              : {
                                color: `${config["colors"]["complete-block"]}`,
                              }
                          }
                          key={index}
                        >
                          {item["name"]}
                        </h4>
                        <div
                          className="process-vin"
                          style={
                            feedbackReceived.includes(item.tag)
                              ? {
                                border: "2px solid red",
                              }
                              : {
                                border: `2px solid ${config["colors"]["complete-block"]}`,
                                opacity:
                                  feedBackPopUp.current &&
                                    feedBackPopUp.current.style.display ===
                                    "flex"
                                    ? ".5"
                                    : "",
                              }
                          }
                          onClick={() => {
                            if (feedbackReceived.includes(item.tag)) {
                              tempStoredFeedBack = item;
                              let feedbackMsg = getTotalImageFeedbackMssg();
                              stencilUrl = Object.keys(item).includes(
                                "stencils",
                              )
                                ? item["stencils"]
                                : "";

                              setShadowUrl(
                                Object.keys(item).includes("shadowBox")
                                  ? item["shadowBox"]
                                  : "",
                              );
                              showFeedBackMssg(feedbackMsg[item.tag]);
                            }
                          }}
                        >
                          {!feedbackReceived.includes(item.tag) && (
                            <div
                              className="greenCircleTick"
                              style={
                                feedBackPopUp.current &&
                                  feedBackPopUp.current.style.display === "flex"
                                  ? { opacity: ".5" }
                                  : {}
                              }
                            >
                              <img src={white_tick} alt="1232"></img>
                            </div>
                          )}
                          <SafeImage
                            style={
                              ["Left Capture", "Right Capture"].includes(
                                item["tag"],
                              ) &&
                                ["client_1525", "client_1671"].includes(clientId)
                                ? { objectFit: "fill" }
                                : {}
                            }
                            src={item["image"]}
                            alt="123"
                          />
                        </div>
                      </div>
                    </div>
                  );
                } else if (
                  Object.keys(getTotalImageFeedbackMssg()).length > 0 &&
                  Object.keys(getTotalImageFeedbackMssg()).includes(item.tag) &&
                  currentBlock["link"] ===
                  "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_360+view.svg"
                ) {
                  return (
                    <div key={index}>
                      <div
                        className="menu-options"
                        style={reduce ? { fontSize: "10px" } : null}
                      >
                        <h4
                          style={
                            feedbackReceived.includes(item.tag)
                              ? {
                                color: "red",
                              }
                              : {
                                color: `${config["colors"]["complete-block"]}`,
                              }
                          }
                          key={index}
                        >
                          {item["name"]}
                        </h4>
                        <div
                          className="process-vin"
                          style={
                            feedbackReceived.includes(item.tag)
                              ? {
                                border: "2px solid red",
                              }
                              : {
                                border: `2px solid ${config["colors"]["complete-block"]}`,
                                opacity:
                                  feedBackPopUp.current &&
                                    feedBackPopUp.current.style.display ===
                                    "flex"
                                    ? ".5"
                                    : "",
                              }
                          }
                          onClick={() => {
                            if (feedbackReceived.includes(item.tag)) {
                              tempStoredFeedBack = item;
                              let feedbackMsg = getTotalImageFeedbackMssg();
                              stencilUrl = Object.keys(item).includes(
                                "stencils",
                              )
                                ? item["stencils"]
                                : "";

                              setShadowUrl(
                                Object.keys(item).includes("shadowBox")
                                  ? item["shadowBox"]
                                  : "",
                              );
                              showFeedBackMssg(feedbackMsg[item.tag]);
                            }
                          }}
                        >
                          {!feedbackReceived.includes(item.tag) && (
                            <div
                              className="greenCircleTick"
                              style={
                                feedBackPopUp.current &&
                                  feedBackPopUp.current.style.display === "flex"
                                  ? { opacity: ".5" }
                                  : {}
                              }
                            >
                              <img src={white_tick} alt="1232"></img>
                            </div>
                          )}
                          <SafeImage
                            style={
                              ["Left Capture", "Right Capture"].includes(
                                item["tag"],
                              ) &&
                                ["client_1525", "client_1671"].includes(clientId)
                                ? { objectFit: "fill" }
                                : {}
                            }
                            src={item["image"]}
                            alt="123"
                          />
                        </div>
                      </div>
                    </div>
                  );
                } else if (
                  subCondition[currentBlock.id][item.name] === "completed"
                ) {
                  return (
                    <div key={index}>
                      <div
                        className="menu-options"
                        style={reduce ? { fontSize: "10px" } : null}
                      >
                        {item["mandatory"] ? (
                          <h4
                            style={{
                              color:
                                getKotakRecaptureCase() && !getRecaptureColorCoding() &&
                                  getKotakRecapSubSection(
                                    currentBlock["tag"],
                                    item["tag"],
                                  )
                                  ? "rgb(0, 180, 160)"
                                  : config["colors"]["complete-block"],
                            }}
                            key={index}
                          >
                            {item["name"]}&#42;
                          </h4>
                        ) : (
                          <h4
                            style={{
                              color:
                                getKotakRecaptureCase() && !getRecaptureColorCoding() &&
                                  getKotakRecapSubSection(
                                    currentBlock["tag"],
                                    item["tag"],
                                  )
                                  ? "rgb(0, 180, 160)"
                                  : config["colors"]["complete-block"],
                            }}
                            key={index}
                          >
                            {item["name"]}
                          </h4>
                        )}
                        <div
                          className="process-vin"
                          style={{
                            border:
                              getKotakRecaptureCase() && !getRecaptureColorCoding() &&
                                getKotakRecapSubSection(
                                  currentBlock["tag"],
                                  item["tag"],
                                )
                                ? "2px solid rgb(0, 180, 160)"
                                : `2px solid ${config["colors"]["complete-block"]}`,
                            opacity:
                              feedBackPopUp.current &&
                                feedBackPopUp.current.style.display === "flex"
                                ? ".5"
                                : "",
                          }}
                          onClick={() => {
                            if (
                              Object.keys(config).includes(
                                "recaptureAfterSubmit",
                              ) &&
                              config["recaptureAfterSubmit"] &&
                              getKotakRecaptureCase() &&
                              !getKotakRecapSubSection(
                                currentBlock["tag"],
                                item["tag"],
                              )
                            ) {
                              //patLogs(`${item["tag"]} is clicked`, inspectionId);
                              currentSubBlock = item["name"];
                              currentTag = item["tag"];
                              stencilUrl = Object.keys(item).includes(
                                "stencils",
                              )
                                ? item["stencils"]
                                : "";

                              setShadowUrl(
                                Object.keys(item).includes("shadowBox")
                                  ? item["shadowBox"]
                                  : "",
                              );
                              setShowOptions(false);
                              imageCaptured = false;
                              startCamera();
                              Object.keys(item).includes("cameraInstruction") &&
                                setInstructions(item["cameraInstruction"]);
                            }
                          }}
                        >
                          <div
                            className="greenCircleTick"
                            style={
                              feedBackPopUp.current &&
                                feedBackPopUp.current.style.display === "flex"
                                ? { opacity: ".5" }
                                : {
                                  backgroundColor:
                                    getKotakRecaptureCase() && !getRecaptureColorCoding() &&
                                      getKotakRecapSubSection(
                                        currentBlock["tag"],
                                        item["tag"],
                                      )
                                      ? "rgb(0, 180, 160)"
                                      : "",
                                }
                            }
                          >
                            <img src={white_tick} alt="1232"></img>
                          </div>
                          <SafeImage
                            style={
                              ["Left Capture", "Right Capture"].includes(
                                item["tag"],
                              ) &&
                                ["client_1525", "client_1671"].includes(clientId)
                                ? { objectFit: "fill" }
                                : {}
                            }
                            src={item["image"]}
                            alt="123"
                          />
                        </div>
                      </div>
                    </div>
                  );
                }
                return (
                  <div key={index}>
                    <div
                      className="menu-options"
                      style={reduce ? { fontSize: "10px" } : null}
                    >
                      {item["mandatory"] ? (
                        <h4 key={index}>{item["name"]}&#42;</h4>
                      ) : (
                        <h4 key={index}>{item["name"]}</h4>
                      )}
                      <div
                        className="process-vin"
                        style={{
                          border: `1px solid ${incompleteBlockColor(config)}`,
                        }}
                        onClick={() => {
                          //patLogs(`${item["tag"]} is clicked`, inspectionId);
                          currentSubBlock = item["name"];
                          currentTag = item["tag"];
                          stencilUrl = Object.keys(item).includes("stencils")
                            ? item["stencils"]
                            : "";

                          setShadowUrl(
                            Object.keys(item).includes("shadowBox")
                              ? item["shadowBox"]
                              : "",
                          );
                          setShowOptions(false);
                          imageCaptured = false;
                          startCamera();
                          Object.keys(item).includes("cameraInstruction") &&
                            setInstructions(item["cameraInstruction"]);
                        }}
                      >
                        <SafeImage
                          style={
                            ["Left Capture", "Right Capture"].includes(
                              item["tag"],
                            ) &&
                              ["client_1525", "client_1671"].includes(clientId)
                              ? { objectFit: "fill" }
                              : {}
                          }
                          src={item["image"]}
                          alt="123"
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div
              className="right-btn"
              disabled={scrolEnd}
              style={alignment ? { display: "none" } : {}}
              onClick={() => slide(+200)}
            >
              <img
                src={rightArrow}
                style={scrolEnd ? { opacity: "0.3" } : {}}
              />
            </div>
          </div>
          <div style={{ display: "flex" }} className="InternetWarning">
            <p>{showAlert && showAlert}</p>
          </div>
          <div
            className="modal-btn-container-multipleImage"
            style={{ display: "flex", backgroundColor: "#F8F7FC" }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignContent: "center",
                width: "100%",
              }}
            >
              <Button
                secoundaryBtn="true"
                text={config["multiple-image-page"]["back-btn-text"]}
                disabled={
                  currentBlock["tag"] === "360 Image" &&
                  feedBackStatus() === "Feedback"
                }
                onclick={goBack}
                marginDefault="0px 0px 0px 0px"
              />
              <Button
                text={config["multiple-image-page"]["next-btn-text"]}
                disabled={
                  (feedBackBtndisabled &&
                    Object.keys(config).includes("imageFeedback") &&
                    currentBlock.tag === "360 Image") ||
                  !getSubMandatoryCompleted()
                }
                onclick={() => {
                  if (
                    Object.keys(config).includes("imageFeedback") &&
                    currentBlock.tag === "360 Image"
                  ) {
                    if (feedBackBtndisabled === false) {
                      modal();
                    }
                  } else {
                    modal();
                  }
                }}
                marginDefault="0px 25px 0px 25px"
              />
            </div>
          </div>
          <div
            ref={modalRef}
            className="menu-modal-container"
            style={{ display: "none" }}
          >
            {!getSubMandatoryCompleted() ? (
              <div className="menu-modal">
                <div className="menu-back-btn">
                  <i className="fas fa-times fa-lg" onClick={removeModal}></i>
                </div>
                <h4>{config["multiple-image-page"]["mandatory-modal-text"]}</h4>
                <h4>{mandatoryMissing.join(", ")}</h4>
              </div>
            ) : getSubMandatoryCompleted() && !getSubCompleted() ? (
              <div className="menu-modal">
                <div className="menu-back-btn">
                  <i className="fas fa-times fa-lg" onClick={removeModal}></i>
                </div>
                <h4>{config["multiple-image-page"]["optional-modal-text"]}</h4>
                <h4>{subMissing.join(", ")}</h4>
                <div className="modal-btn-container">
                  <Button
                    text={config["multiple-image-page"]["modal-btn-next"]}
                    onclick={() => {
                      setStepCovered([...stepCovered]);
                      patLogs(
                        `Warning given to user some module is not completed still user clicked final submit button`,
                        inspectionId,
                      );
                      imageAnalysis();
                    }}
                  />
                </div>
              </div>
            ) : getSubCompleted() ? (
              <div className="menu-modal">
                <div className="menu-back-btn">
                  <i className="fas fa-times fa-lg" onClick={removeModal}></i>
                </div>
                <h4>{config["multiple-image-page"]["back-modal-text"]}</h4>
              </div>
            ) : null}
          </div>
        </div>
      ) : (
        <div id="vin-screen" ref={singleScreen}>
          <canvas
            ref={canvasRef}
            id="ios-canvas"
            style={
              getAspectRatioClientList(clientId, config)
                ? {
                  width: "100vw",
                  height: "100vh",
                  objectFit: "contain",
                  backgroundColor: "black",
                }
                : {}
            }
          ></canvas>
          <div
            style={{ width: "100dvw", height: "100dvh", position: "absolute", display: "flex" }}
          >
            <video
              ref={videoRef}
              id="videoWindow"
              style={
                isStreamRotated
                  ? {
                    width: "100vh",
                    height: "100vw",
                    objectFit: getAspectRatioClientList(clientId, config) ? "contain" : "cover",
                    backgroundColor: "black",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%) rotate(90deg)",
                  }
                  : getAspectRatioClientList(clientId, config)
                    ? {
                      width: "100vw",
                      height: "100vh",
                      objectFit: "contain",
                      backgroundColor: "black",
                      position: "absolute",
                      top: 0,
                      left: 0,
                    }
                    : { position: "absolute", top: 0, left: 0 }
              }
              autoPlay
              playsInline
            ></video>
            <div
              className="stencilBox"
              ref={stencilBoxRef}
              style={{
                position: "absolute",
                // border: "1px solid red",
              }}
            >
              <SafeImage
                src={stencilUrl}
                alt=""
                fallback={null}
                style={
                  /iPad|iPhone|iPod/.test(navigator.userAgent) &&
                    !window.MSStream
                    ? {
                      width: "90%",
                      height: "90%",
                      objectFit: "contain",
                    }
                    : { width: "100%", height: "100%", objectFit: "contain" }
                }
              />
            </div>
          </div>
          {["sompo_motorbike"].includes(clientId) && (
            <div
              className="redLineVINcontainerView"
              style={{
                paddingTop: "5%",
                justifyContent: "flex-start",
                width: "unset",
              }}
              ref={redLineVINcontainer}
            >
              <div id="modalNameCont">
                <p id="modalNameText">{currentSubBlock}</p>
              </div>
            </div>
          )}
          {shadowUrl && (
            <SafeImage src={shadowUrl} alt="" className="car-stencil" fallback={null} />
          )}
          <div
            ref={startBtn}
            style={{
              backgroundImage: `url(${cameraImg})`,
              backgroundSize: "37px 37px",
              backgroundRepeat: "no-repeat",
              objectFit: "cover",
              backgroundPosition: "center",
            }}
            onClick={captureImg}
            id="btn-vin-start"
          ></div>
          <div className="back-btn">
            <i className="fas fa-arrow-left fa-2x" onClick={back}></i>
          </div>
          {instructions && (
            <div className="camerInst">
              <p>{instructions}</p>
            </div>
          )}
          <div
            id="vin-image"
            style={
              getAspectRatioClientList(clientId, config)
                ? { backgroundColor: "black", objectFit: "contain" }
                : {}
            }
            ref={imgRef}
          >
            {/* <img
              ref={divImgRef}
              style={
                Object.keys(config).includes("aspectRatio")
                  ? { objectFit: "contain" }
                  : { width: "100vw", height: "100vh" }
              }
            /> */}
            <img
              ref={divImgRef}
              style={
                getAspectRatioClientList(clientId, config)
                  ? { objectFit: "contain" }
                  : { width: "100vw", height: "100vh" }
              }
            />
            {
              getNewConfirmBtn() ? (
                <>
                  <div style={{ position: "absolute", display: "flex", width: "100%", alignItems: "center", justifyContent: "center", alignContent: "center", top: "10%" }}>
                    <div id="modalNameCont" style={{ fontSize: "16px" }}>
                      <p id="modalNameText">{currentSubBlock + " (" + getTranslateText("Preview") + ")"}</p>
                    </div>
                  </div>
                  <button
                    className="new-retake-btn"
                    style={{ backgroundColor: config["colors"]["crossBtn"] ? config["colors"]["crossBtn"] : "#FF8C00" }}
                    onClick={imageRetake}
                  >
                    <i className="fas fa-undo"></i>
                    {getTranslateText("Recapture")}
                  </button>
                  <button
                    className="new-next-btn"
                    style={{ backgroundColor: config["colors"]["btn"] }}
                    onClick={imageNext}
                  >
                    <i className="fas fa-check"></i>
                    {getTranslateText("Done")}
                  </button>
                </>
              ) : (
                <>
                  <i
                    className="fas fa-times fa-2x vin-btn-retake"
                    onClick={imageRetake}
                  ></i>
                  <i
                    className="fas fa-check fa-2x vin-btn-next"
                    onClick={imageNext}
                  ></i>
                </>
              )
            }

            <div ref={gettingDocFeedback} className="feedbackDoc">
              <h3 ref={gettingDocFeedbackText}></h3>
              <button
                style={{ backgroundColor: config["colors"]["btn"] }}
                ref={gettingDocFeedbackButton}
                onClick={() => {
                  checkdoc = null;
                  feedBackStatusOnce = false;
                  gettingDocFeedback.current.style.display = "none";
                  imageRetake();
                }}
              >
                {getTranslateText("Recapture image")}
              </button>
            </div>

            <div ref={successDOcFeedback} className="feedbackDoc">
              <h3>{getTranslateText("Document validated successfully!")}</h3>
            </div>
          </div>
        </div >
      )
      }
    </Fragment >
  );
};

export default MultipleImage;
